/**
 * Login page — Phase B.5
 * Public route. Single CTA "Continue with Google" → redirects to
 * Emergent Auth proxy. Hosted domain restriction is enforced on the
 * backend (calyfx.com + hererbrands.com only).
 */
import React from "react";
import { LogIn, ShieldCheck } from "lucide-react";
import { Button } from "../components/ui/button";
import { useAuth } from "../lib/AuthProvider";

export default function Login() {
  const { login } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-950 text-zinc-100 p-6">
      <div className="w-full max-w-md space-y-6 fade-up">
        <div className="text-center space-y-2">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-emerald-500/15 border border-emerald-500/30 text-emerald-300 mb-2">
            <ShieldCheck className="w-7 h-7" />
          </div>
          <h1 className="text-3xl font-semibold tracking-tight">JackTrack</h1>
          <p className="text-sm text-zinc-400 leading-relaxed">
            Jack Enterprises internal CRM.
            <br />
            Sign in with your work Google account to continue.
          </p>
        </div>

        <div className="panel p-6 space-y-4 bg-zinc-900/40 border border-zinc-800 rounded-xl">
          <Button
            data-testid="login-google-btn"
            onClick={login}
            className="w-full h-11 bg-white hover:bg-zinc-100 text-zinc-900 font-medium gap-2"
          >
            <svg viewBox="0 0 24 24" className="w-5 h-5">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.75h3.57c2.08-1.92 3.28-4.74 3.28-8.07z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.75c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.12c-.22-.66-.35-1.36-.35-2.12s.13-1.46.35-2.12V7.04H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.96l3.66-2.84z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.04l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/>
            </svg>
            Continue with Google
          </Button>
          <p className="text-[11px] text-zinc-500 leading-relaxed text-center">
            Only <span className="text-zinc-300 font-mono">@calyfx.com</span> and{" "}
            <span className="text-zinc-300 font-mono">@hererbrands.com</span> emails are accepted.
            <br />
            Not on the list yet? Ask an admin (Matt / Rich / Dennis) to invite you.
          </p>
        </div>

        <p className="text-[11px] text-zinc-600 text-center font-mono">
          JackTrack v0.5 · Phase B.5 · Jack Enterprises
        </p>
      </div>
    </div>
  );
}
